export default __webpack_public_path__ + "static/media/last6.b1f30538.jpg";